/* eslint-disable max-depth */
import React from "react";
import FeedsFilters from "web/react/components/feeds-filters/feeds-filters";
import { PageManager } from "web/react/components/feeds-filters/feeds-filters-pagination/pagination-state";
import { FilterManager } from "web/react/components/feeds-filters/hooks/use-filter-manager";
import Overlay from "web/react/components/overlay/overlay";
import { useSidebarHandler } from "../feeds-filters/hooks/use-sidebar-handler";
import styles from "./filter-overlay.css";

interface FilterOverlayProps {
    filterManager: FilterManager;
    pageManager: PageManager;
}

const FilterOverlay = function FilterOverlay({ filterManager, pageManager }) {
    const [isOpen, closeSidebar] = useSidebarHandler();

    const { cancelState, applyState, updateFromServer, ...otherFilterProps } = filterManager;
    const {
        popActivePage,
        pushActivePage,
        paginationState,
        resetPagination,
        title: overlayTitle,
    } = pageManager;

    function closeAndCancel(): void {
        closeSidebar();
        cancelState();
        resetPagination();
    }

    function handleApply(): void {
        closeSidebar();
        applyState();
        resetPagination();
    }

    function onOverlayBack(): void {
        if (!paginationState.hasActivePage()) {
            closeAndCancel();
            return;
        }
        popActivePage();
        updateFromServer();
    }

    return (
        <Overlay
            contentClassName={styles.overlayContent}
            isOpen={isOpen}
            onBack={onOverlayBack}
            onRequestClose={closeAndCancel}
            peek={true}
            title={overlayTitle}
        >
            <FeedsFilters
                onPageChange={pushActivePage}
                paginationState={paginationState}
                applyState={handleApply}
                {...otherFilterProps}
            />
        </Overlay>
    );
} as React.FC<FilterOverlayProps>;

export default FilterOverlay;
